import { isRouteErrorResponse } from "react-router";

import { isApiError } from "@/api/client";

export type RouteErrorKind = "not-found" | "stale-build" | "unexpected";

/**
 * Messages browsers (and Vite's preload helper) use when a lazily imported chunk
 * can't be fetched — typically because a deploy replaced the hashed files.
 */
const CHUNK_LOAD_ERROR =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|unable to preload css|loading (css )?chunk [\w-]+ failed/i;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && (error.name === "ChunkLoadError" || CHUNK_LOAD_ERROR.test(error.message));
}

export function classifyRouteError(error: unknown): RouteErrorKind {
  if ((isRouteErrorResponse(error) || isApiError(error)) && error.status === 404) return "not-found";
  if (isChunkLoadError(error)) return "stale-build";
  return "unexpected";
}

/** A short technical description of the error for the "details" disclosure, if there is one. */
export function errorDetails(error: unknown): string | null {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`.trim();
  if (error instanceof Error) return error.message || error.name;
  if (typeof error === "string" && error) return error;
  return null;
}
